export default {"src":"/_next/static/media/readySite2.2e845fb0.svg","height":192,"width":220,"blurWidth":0,"blurHeight":0};